import { createTheme, type MantineThemeOverride } from '@mantine/core';

/**
 * Оформление рассчитано на два разных устройства.
 *
 * Колл-центр сидит за монитором с мышью, замерщик тычет пальцем в планшет
 * стоя в пыльной квартире. Поэтому базовые размеры элементов увеличены
 * против стандартных: попасть пальцем в кнопку 36 px, держа планшет одной
 * рукой, не получается.
 */
export const theme: MantineThemeOverride = createTheme({
  primaryColor: 'blagodar',
  colors: {
    blagodar: [
      '#eff4ff',
      '#dbe6fe',
      '#bfd3fe',
      '#93b4fd',
      '#608dfa',
      '#3b76f6',
      '#2563eb',
      '#1d4fd8',
      '#1e40af',
      '#1e3a8a',
    ],
  },
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  defaultRadius: 'md',
  components: {
    Button: { defaultProps: { size: 'md' } },
    TextInput: { defaultProps: { size: 'md' } },
    NumberInput: { defaultProps: { size: 'md' } },
    Select: { defaultProps: { size: 'md' } },
    Textarea: { defaultProps: { size: 'md' } },
  },
});
